export default "__VITE_ASSET__BRbdnWEJ__"